import React from 'react';

const HeaderBottomContents = () => {
    return (
        <section className="d-flex container text-center mb-5 pb-5">
            <div>
                <img className="w-50 " src="https://i.ibb.co/dBNX18Z/slack.png" alt=""/>
            </div>
            <div>
                <img className="w-50 " src="https://i.ibb.co/7r656cB/google.png" alt="" />
            </div>
            <div>
                <img className="w-50 " src="https://i.ibb.co/FH2RPfk/uber.png" alt="" />
            </div>
            <div>
                <img className="w-50 " src="https://i.ibb.co/R6N72zj/netflix.png" alt="" />
            </div>
            <div>
                <img className="w-50 " src="https://i.ibb.co/NY1m026/airbnb.png" alt="" />
            </div>
        </section>
    );
};

export default HeaderBottomContents;